import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getText } from '../utils/helper';
import { useSelector } from 'react-redux';
import { logger } from '../utils/logger';
import { captureException } from '../utils/sentry';

class ErrorBoundaryClass extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        logger.error('Error caught by boundary:', error, errorInfo);
        captureException(error, { contexts: { react: errorInfo } });
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return <ErrorFallback onReset={() => this.setState({ hasError: false, error: null, errorInfo: null })} />;
        }

        return this.props.children;
    }
}

const ErrorFallback = ({ onReset }) => {
    const navigate = useNavigate();
    const lang = useSelector((state) => state.app.lang) || 'nameRu';

    const handleGoHome = () => {
        onReset();
        navigate('/');
    };

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            minHeight: '100vh',
            padding: '20px'
        }}>
            <Result
                status="500"
                title={getText('Что-то пошло не так', lang)}
                subTitle={getText('Произошла непредвиденная ошибка. Пожалуйста, попробуйте обновить страницу.', lang)}
                extra={[
                    <Button type="primary" key="home" onClick={handleGoHome}>
                        {getText('На главную', lang)}
                    </Button>,
                    <Button key="reload" onClick={handleReload}>
                        {getText('Обновить страницу', lang)}
                    </Button>,
                ]}
            />
        </div>
    );
};

export default ErrorBoundaryClass;
